import {
    USER_GET_FRUI_QPPZ_LIST_BEGIN,
    USER_GET_FRUI_QPPZ_LIST_SUCCESS,
    USER_GET_FRUI_QPPZ_LIST_FAILURE,
    USER_GET_FRUI_QPPZ_LIST_DISMISS_ERROR,
  } from './constants';
  
  import request from '../../../utils/request'
  // Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
  // If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
  export function getFrui_qppzList(params) {
    return (dispatch) => { // optionally you can have getState as the second argument
      dispatch({
        type: USER_GET_FRUI_QPPZ_LIST_BEGIN,
      });
     params.size = 10;

     const promise = new Promise((resolve, reject) => {
          request({
            method:'get',
            url:'/api/basic/gc',
            data:params,
          }).then( data => {
              dispatch({
                  type: USER_GET_FRUI_QPPZ_LIST_SUCCESS,
                  data: Object.assign({},data,{page:params.page}),
              });
              resolve(data);
          }).catch (error => {
              dispatch({
                type: USER_GET_FRUI_QPPZ_LIST_FAILURE,
                data: { error: error },
              });
              reject(error);
          })
      });
  
      return promise;
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissGetFrui_qppzListError() {
    return {
      type: USER_GET_FRUI_QPPZ_LIST_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case USER_GET_FRUI_QPPZ_LIST_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          getFrui_qppzListPending: true,
          getFrui_qppzListError: null,
        };
  
      case USER_GET_FRUI_QPPZ_LIST_SUCCESS:
        // The request is success
   
        const byId = {};
        const items = [];
        action.data.data.forEach(item => {
          items.push(item.id);
          byId[item.id] = item;
        });
        return {
          ...state,
          frui_qppzById:byId,
          frui_qppzList:items,
          frui_qppzPage: action.data.page,
          frui_qppzSize: action.data.size,
          frui_qppzTotal: action.data.count,
          getFrui_qppzListPending: false,
          getFrui_qppzListError: null,
        };
  
      case USER_GET_FRUI_QPPZ_LIST_FAILURE:
        // The request is failed
        return {
          ...state,
          getFrui_qppzListPending: false,
          getFrui_qppzListError: action.data.error,
        };
  
      case USER_GET_FRUI_QPPZ_LIST_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          getFrui_qppzListError: null,
        };
  
      default:
        return state;
    }
  }


// WEBPACK FOOTER //
// ./src/features/user/redux/getFrui_qppzList.js